// extracted by mini-css-extract-plugin
export default {"container":"AdminLayout_container__R6J5G","card-content":"AdminLayout_card-content__0wOWp"};